import {Injectable} from '@angular/core';
import {api, handleError} from '../../shared/api-loaders';
import {Observable, of as observableOf} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {ConversionEnvironment} from '../model/ConversionEnvironment';
import {ConversionCorporation} from '../model/ConversionCorporation';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ConversionFacility} from '../model/ConversionFacility';
import {ConversionUnits} from '../model/ConversionUnits';
import {ConversionDocumentTypes} from '../model/ConversionDocumentTypes';
import {ConversionResidents} from '../model/ConversionResidents';
import {DocumentSession} from '../model/DocumentSession';



@Injectable({
  providedIn: 'root'
})
export class ConversionsReferenceDataService {


  constructor(private _http: HttpClient) {
  }
 /* with use of http client dont have to map data explicitly like old way map(data => data.json()) just provide mapping object within get<>.
  tap operator taps into the observable stream and allows to look at emitted values in the stream without transforming the stream- good for debugging or logging
*/

  public getConversionEnvironments(): Observable<ConversionEnvironment[]> {
    return this._http
      .get<ConversionEnvironment[]>(api.conversionsEnvironment()).pipe(
      /*  tap(data => console.log('all:' + JSON.stringify(data))),*/
        catchError(handleError));
  }

  public getConversionCorporations(environmentID: string): Observable<ConversionCorporation[]> {
    return this._http
      .get<ConversionCorporation[]>(api.conversionsCorporations(environmentID)).pipe(
        /*tap(data => console.log('all:' + JSON.stringify(data))),*/
        catchError(handleError));
  }

  public getConversionFacilities(environmentID: string, corporationID: string): Observable<ConversionFacility[]> {
    return this._http
      .get<ConversionFacility[]>(api.conversionsFacilities(environmentID, corporationID)).pipe(
        /*tap(data => console.log('all:' + JSON.stringify(data))),*/
        catchError(handleError));
  }

  public getConversionUnits(environmentID: string, facilityId: string): Observable<ConversionUnits[]> {
    return this._http
      .get<ConversionUnits[]>(api.conversionsUnits(environmentID, facilityId)).pipe(
       /* tap(data => console.log('all:' + JSON.stringify(data))),*/
        catchError(handleError));
  }

  public getConversionDocumentTypes(environmentID: string, facilityId: string): Observable<ConversionDocumentTypes[]> {
    return this._http
      .get<ConversionDocumentTypes[]>(api.conversionsDocTypes(environmentID, facilityId)).pipe(
      /*  tap(data => console.log('all:' + JSON.stringify(data))),*/
        catchError(handleError));
  }

  public getConversionResidents(environmentID: string, facilityId: string, units: string, documentTypes: string, dates: string): Observable<ConversionResidents[]> {
    return this._http
      .get<ConversionResidents[]>(api.conversionsResidents(environmentID, facilityId, units, documentTypes, dates)).pipe(
        /*tap(data => console.log('allas:' + JSON.stringify(data))),*/
        catchError(handleError));
  }

  public saveDocumentSession(documentSession: string): Observable<string> {
    return this._http
      .post(api.saveDocumentSession(), documentSession).pipe(
        catchError(handleError));

  }

  public transferDocuments(documentSession: string, sessionId: string) {
    return this._http
      .post(api.transferDocuments(sessionId), documentSession,).pipe(
        catchError(handleError));
  }

  public getResidentDocumentSessions(): any {
    return this._http
      .get(api.getResidentDocumentSessions()).pipe(
      /*  tap(data => console.log('allas:' + data)),*/
        catchError(handleError));
  }


  public removeSessionDetails(key: string) {
    return this._http
      .delete(api.removeSessionDetailsFromCache(key)).pipe(
        catchError(handleError));
  }

  public cancelSession(sessionId: string) {
    return this._http.post(api.cancelSession(), sessionId).pipe(
      catchError(handleError));
  }

}

